import { useNarrow } from '../../../lib/use-narrow';
import { YourAgentsDesktop } from './YourAgentsDesktop';
import { YourAgentsMobile } from './mobile/YourAgentsMobile';

// Your Agents, Symphony. The two viewports are genuinely different screens — wide sets the
// genome beside an overlapping card pile, narrow stacks a full-bleed team band over a
// horizontal card carousel (Figma `8509:36899`) — so they are two components rather than one
// with breakpoint branches. Everything they DO is shared: `useYourAgents` owns the reads, the
// genome/roster selection and the team-level actions.
export function YourAgentsBody() {
  const narrow = useNarrow();
  return narrow ? <YourAgentsMobile /> : <YourAgentsDesktop />;
}
